import styled from "styled-components";

const ActivityWrapper = styled.div`
  .activity_form .form_padding {
    padding: 12px;
  }

  .activity_form .item_half_width {
    flex: 1;
  }
`;

export default ActivityWrapper;
